var viewer_caption_default = {
  "fontElementMap": "xviZj",
  "imageCaption": "dgP-u"
};
export {
  viewer_caption_default as default
};
//# sourceMappingURL=viewer-caption-scss.js.map
